import { Injectable } from '@angular/core';
import { NavigationError } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RouterErrorHandlerService {
  public trackError(e: NavigationError) {
    console.warn('Router error: ', e);

    location.href = location.origin + e.url;
  }
}
